import ReactECharts from "echarts-for-react";

import { useAppDispatch } from "store/hook";
import { setL1Visible, setOnEventValues } from "Components/Report/reportSlice";
// import MultiDrawer from "Components/Report/OnDemand/MultiDrawer";
import { useChartParam, Parameter } from "Components/Report/OnDemand/charts/shared/utils";
import ChartCard from "Components/Report/OnDemand/charts/shared/ChartCard";
import { getConfig } from "Components/Report/OnDemand/charts/shared/config";
import { ReportDeviceStatus, ReportAccountStatus } from "Utility/Types/report";
import { useReportClick } from "Components/Report/queries";
import { useAppSelector } from "store/hook";
import { hoverFormat } from "./shared/utils";
// const xAxis = Array.from({ length: 31 }, (_, i) => i + 1);
// const seriesData = Array.from({ length: 31 }, (_, i) => i + Math.random() * i);
interface T {
  offline: number[];
  critical: number[];
  warning: number[];
}

const HealthBar = ({
  param,
  id = "",
  data,
  isFetching,
  name,
}: {
  param: Parameter;
  id?: string;
  data?: ReportDeviceStatus[] | ReportAccountStatus[];
  isFetching: boolean;
  name?: string;
}) => {
  const disp = useAppDispatch();
  const { title, Ymax, Yunit, Xaxis, Xunit, isDarkMode } = useChartParam(param, id, data, name);
  const { mutateAsync: getClickMutation } = useReportClick();
  const { level, stateCid, loginCid } = useAppSelector((state) => state.global);
  const { filterForm } = useAppSelector((state) => state.report);
  const seriesData = (data as (ReportDeviceStatus & ReportAccountStatus)[])?.reduce<T>(
    (a, b) => {
      return {
        ...a,
        offline: [...a.offline, b?.system?.alarm?.[id === "" ? "offline_devices" : "offline"]],
        critical: [...a.critical, b?.system?.alarm?.[id === "" ? "critical_devices" : "critical"]],
        warning: [...a.warning, b?.system?.alarm?.[id === "" ? "warning_devices" : "warning"]],
      };
    },
    {
      offline: [],
      critical: [],
      warning: [],
    }
  );

  const getClickData = (values: any) => {
    if (!data) {
      return;
    }

    const { start_utc, end_utc, unit } = data[values.dataIndex];

    getClickMutation({
      duration: { start_utc, end_utc, unit },
      level,
      stateCid,
      loginCid,
      account_devices: filterForm.account_device,
    }).then((data) => {
      const eventValue = { ...data.response[0], click: values.seriesName.toLowerCase(), type: "health" };
      disp(setL1Visible(true));
      disp(setOnEventValues(eventValue));
    });
  };

  const config = getConfig({
    isDarkMode,
    tooltip: {
      trigger: "axis",
      formatter: function (params) {
        return hoverFormat(params, data);
      },
    },
    xAxis: [{ data: Xaxis, name: Xunit, axisLabel: { color: isDarkMode ? "white" : "gray" } }],
    yAxis: [
      {
        name: Yunit,
        max:
          Ymax ||
          function (value: any) {
            return value.max + 3;
          },
        axisLabel: {
          color: isDarkMode ? "white" : "gray",
        },
      },
    ],
    series: [
      {
        name: "Offline",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: isDarkMode ? "darkgray" : "#343a40",
        },
        emphasis: {
          focus: "series",
        },

        data: seriesData?.["offline"],
      },

      {
        name: "Critical",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: "#dc3545",
        },
        emphasis: {
          focus: "series",
        },

        data: seriesData?.["critical"],
      },
      {
        name: "Warning",
        type: "bar",
        stack: "total",
        label: {
          show: false,
        },
        itemStyle: {
          color: "#ffc107",
        },
        emphasis: {
          focus: "series",
        },

        data: seriesData?.["warning"],
      },
    ],
    legend: {
      textStyle: {
        color: isDarkMode ? "white" : "black", // 新增深色模式時 報表字體顏色為 #white
      },
    },
  });

  const onEvent = (values: any) => {
    if (id !== "") {
      return;
    }

    getClickData(values);
  };

  return (
    <ChartCard title={title} param={param} isFetching={isFetching}>
      <ReactECharts
        option={config}
        style={{ height: "100%" }}
        // theme={isDarkMode ? "dark" : "default"}
        onEvents={{ click: (e: any) => onEvent(e) }}
      />
    </ChartCard>
  );
};

export default HealthBar;
